import { registerModuleReducer } from 'utils/modules/reducer';

import { SUB_MODULE_NAME } from './constants';
import { productPageReducer } from './reducers';

registerModuleReducer(SUB_MODULE_NAME, productPageReducer);
